import { images } from "../../assets/images";


export const assignEnrichmentTools = [
{
  id: "project-builder",
  title: "Project Builder",
  iconSrc: images.assign[0],
  href: "#project-builder",
},
{
  id: "activity-generator",
  title: "Activity Generator",
  iconSrc: images.assign[1],
  href: "#activity-generator"
},
{
  id: "real-world-task",
  title: "Real-world Task Generator",
  iconSrc: images.assign[2],
  href: "#real-world-task"
}];